import { useSelector } from "react-redux";
import { Chip } from "@mui/material";
import { Verified } from "@mui/icons-material";
import PropTypes from "prop-types";

import ImagesGallery from "../../../../../components/ImagesGallery";
import messages from "../../../../../assets/locale/messages";
import {
  ATTACHMENTS_TYPES,
  CHIPS_CLASSES,
  CURRENCIES_SYMBOLS,
  PRODUCT_STATUS,
  PRODUCT_STATUS_IDS
} from "../../../../../utils/Constants";

const MainInfoSection = ({ productDetails }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { products } = messages[lang];

  const getChipClass = (status) => {
    switch (status) {
      case PRODUCT_STATUS.pending:
        return CHIPS_CLASSES.yellow;
      case PRODUCT_STATUS.published:
        return CHIPS_CLASSES.green;
      case PRODUCT_STATUS.rejected:
      case PRODUCT_STATUS.unpublished:
      case PRODUCT_STATUS.deleted:
        return CHIPS_CLASSES.red;
      default:
        break;
    }
  };

  const renderLabelValue = (label, value, isChip) => (
    <div className="row mb-3">
      <div className="col-md-5 col-4 d-flex align-items-center">
        <p className="text-color mb-0">{label}</p>
      </div>
      <div className="col-md-7 col-8">
        {isChip ? (
          <Chip
            label={products.productDetails.status[value]}
            className={`${getChipClass(value)}`}
          />
        ) : (
          <span className="d-block mb-3 title-color fweight-500 mb-0">
            {value}
          </span>
        )}
      </div>
    </div>
  );

  const renderPricingRanges = () => (
    <div className="row mb-3">
      <div className="col-md-5 col-4">
        <p className="text-color mb-0">
          {products.productDetails.pricing}
        </p>
      </div>
      <div className="col-md-7 col-8">
        {productDetails?.PriceRanges?.map(
          ({ From, To, Price }, i) => (
            <div key={`price-range-${i}`} className="row mb-2">
              <div className="col-md-8 col-9">
                <p className="title-color fweight-500 mb-0">
                  {From} - {To}{" "}
                  {productDetails?.OtherMoqUnitName ||
                    productDetails?.MoqUnitName}
                </p>
              </div>
              <div className="col-md-4 col-3">
                <p className="title-color fweight-600 mb-0">
                  {!!productDetails.CurrencySymbol &&
                    productDetails.CurrencySymbol}
                  {Price}
                </p>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );

  return (
    <div className="main-info-section mb-5">
      <div className="row">
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="imgs-section">
            <ImagesGallery
              imgsList={
                productDetails?.Attachments?.filter(
                  (attachment) =>
                    attachment?.AttachmentTypeId ===
                    ATTACHMENTS_TYPES.img
                ).map((image) => image?.MediaName) || []
              }
              defaultImg={productDetails?.DefaultImage || ""}
            />
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12 ps-lg-5 product-info-section scroll-within">
          <p className="sub-category-name text-light-grey mb-3">
            {`${productDetails?.CategoryName} | 
            ${productDetails?.SubCategoryName}`}
          </p>
          <h3 className="product-name title-color fsize-22 fweight-700 mb-3">
            {productDetails?.Name}
          </h3>
          {productDetails?.ExporterName && (
            <p className="company-name text-color mb-3">
              {productDetails?.CompanyName}
              <Verified color="primary" className="ms-1" />
            </p>
          )}
          {renderLabelValue(
            products.productDetails.productStatus,
            PRODUCT_STATUS_IDS.find(
              (status) =>
                status.id ===
                (productDetails?.OriginalProductStatusId ??
                  productDetails?.ProductStatusId)
            )?.value,
            true
          )}
          {productDetails?.HsCode &&
            renderLabelValue(
              products.productDetails.productCode,
              productDetails?.HsCode
            )}
          {productDetails?.MinOrderQuantity &&
            renderLabelValue(
              products.productDetails.minimumQuantity,
              `${productDetails?.MinOrderQuantity} ${productDetails?.OtherMoqUnitName || productDetails?.MoqUnitName}`
            )}
          {productDetails?.PriceRanges &&
            !!productDetails?.PriceRanges.length &&
            renderPricingRanges()}
          {productDetails?.Country &&
            renderLabelValue(
              products.productDetails.country,
              productDetails?.Country
            )}
        </div>
      </div>
    </div>
  );
};

export default MainInfoSection;

MainInfoSection.propTypes = {
  productDetails: PropTypes.object.isRequired
};
